// import Raven from 'raven-js'; // - sentry.io logging

function init() {
  // Raven.config(......)
  // must be init in index.js:
  //    import logger from "./services/logService"
  //    logger.init();
}

function log(error) {
  //Raven.captureException(error)
  console.log("Logging the error", error); // temporary dev
}

const logService = { init, log };
export default logService;
